import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let ToDoSuccess = class ToDoSuccess extends Mixins(ViewportSizeMixin) {
    onStay() {
        this.$emit('onStay');
        this.$store.commit('toggleReadySuccessMessage', false);
    }
    toOverview() {
        this.$store.commit('resetTodoSuccessMessage');
        this.$router.push({ name: 'ecommerce-overview' });
        this.$store.commit('toggleReadySuccessMessage', false);
    }
};
__decorate([
    Prop({ type: String, default: null })
], ToDoSuccess.prototype, "caption", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], ToDoSuccess.prototype, "removeStay", void 0);
ToDoSuccess = __decorate([
    Component({
        name: 'ToDoSuccess',
        components: {
            ActionButton,
        },
    })
], ToDoSuccess);
export default ToDoSuccess;
